// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const EducationIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="EducationIcon" ref={forwardedRef} {...props}>
      <path d="M9.997 2.5 20 7.445l-3.662 1.788v5.519l-.072.15C15.73 16.03 13.744 17.75 9.9 17.75c-3.845 0-5.831-1.72-6.368-2.847L3.46 14.752V9.136L0 7.445zM3.393 7.437l6.601 3.228 6.61-3.228L9.997 4.17zm1.581 2.44v4.517C5.35 14.97 6.751 16.257 9.9 16.257s4.548-1.287 4.924-1.863v-4.42l-4.83 2.358z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const EducationIcon = /* @__PURE__ */ Object.assign(
  EducationIconComponent,
  { displayName: 'EducationIcon' },
);
